export const problemsToFixMock = [
  {
    id: 1,
    value: "small_multiple_abnormalities",
    label: "Невеликі множинні порушення позиції зубів",
    checked: false,
  },
  {
    id: 2,
    value: "extruded_tooth",
    label: "Екструзований зуб",
    checked: false,
  },
  {
    id: 3,
    value: "intrusive_tooth",
    label: "Інтрузований зуб",
    checked: false,
  },
  {
    id: 4,
    value: "impaired_tooth_tilt",
    label: "Порушений нахил зуба",
    checked: false,
  },
  {
    id: 5,
    value: "impaired_tooth_angulation",
    label: "Порушена ангуляція зуба",
    checked: false,
  },
  {
    id: 6,
    value: "rotated_tooth",
    label: "Ротований зуб",
    checked: false,
  },
  {
    id: 7,
    value: "tremes_diastemas",
    label: "Треми, діастеми",
    checked: false,
  },
  {
    id: 8,
    value: "crowded_teeth_in_one_jaw",
    label: "Скупченість зубів на одній щелепі",
    checked: false,
  },
  {
    id: 9,
    value: "protrusion",
    label: "Протрузія",
    checked: false,
  },
  {
    id: 10,
    value: "retrusion",
    label: "Ретрузія",
    checked: false,
  },
  {
    id: 11,
    value: "overlapping_teeth",
    label: "Перехресне положення зубів",
    checked: false,
  },
  {
    id: 12,
    value: "narrowing_of_dental_arches_in_the_premolar_area",
    label: "Звуження зубних дуг",
    checked: false,
  },
  {
    id: 13,
    value: "crowded_teeth_in_both_jaws",
    label: "Скупченість зубів на обидві щелепи",
    checked: false,
  },
  {
    id: 14,
    value: "2_class_1_side",
    label: "II клас з Енглю з одного боку",
    checked: false,
  },
  {
    id: 15,
    value: "3_class_1_side",
    label: "III клас з Енглю з одного боку",
    checked: false,
  },
  {
    id: 16,
    value: "2_class_1_subclass",
    label: "II клас з Енглю. Підклас I",
    checked: false,
  },
  {
    id: 17,
    value: "2_class_2_subclass",
    label: "II клас з Енглю. Підклас II",
    checked: false,
  },
  {
    id: 18,
    value: "sagittal_cleft",
    label: "Сагітальна щілина",
    checked: false,
  },
  {
    id: 19,
    value: "overbite",
    label: "Глибокий прикус",
    checked: false,
  },
  {
    id: 20,
    value: "open_bite",
    label: "Відкритий прикус",
    checked: false,
  },
];
